module.exports = __webpack_public_path__ + "static/media/brynden.0ac5992e.jpg";